export default "__VITE_ASSET__Bbk8Pbwg__"